export default __webpack_public_path__ + "static/media/background-large.dd60a5d6.png";